import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Metadata } from "../../core/components/commonApp.js";
import { Helper } from "../../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { SplittingWrapper } from "./splittingDialog.js";
import { ActionDataItem, Assignment, SplitAssignmentActions } from "./splittingDialogTypes.js";
import React from "react";
import ReactDOM from "react-dom";

export enum SplittingDialogResult {
    Error = 0,
    NoAssignments = 1,

    Cancel = 2,
    Success = 3
}

export enum SplittingAction {
    None = 0, // no Action possible because of some restrictions
    MoveToContainer = 1, // move assignment in question to the container (reset driving)
    // CutEnd,
    // CutStart,
    // CutMiddle,
    // CutEndToContainer,
    // CutStartToContainer,
    // CutMiddleToContainer,
    CutOut = 2, // cut intersecting part from assignment in question (the resulting assignments are smaller then source)
    CutOutToContainer = 3, // cut intersecting part from assignment in question and create (the resulting assignments equal to source)
    ExtendToRight = 4, // cut intersecting part and extend the right part according to the cut part (or create right part, if none is left).
    FixWayThere = 5,
    FixWayBack = 6,
    SplitUp = 7
}

export class SplittingDialogUtil {
    static openSplittingWindow = (projNr: string, pIndex: number, cuttingEdge: string | Date, markEvent: (id: string) => void) => {
        return SplittingDialogUtil.openSplittingHelper(projNr, pIndex, cuttingEdge, "window", markEvent);
    }

    static openSplittingDialog = (projNr: string, pIndex: number, cuttingEdge: string | Date) => {
        return SplittingDialogUtil.openSplittingHelper(projNr, pIndex, cuttingEdge, "dialog", null);
    }

    private static openSplittingHelper = (projNr: string, pIndex: number, cuttingEdge: string | Date, wrapperType: "window" | "dialog", markEvent: (id: string) => void = null) => {
        return new Promise<SplittingDialogResult>(async (resolve) => {
            const [result, containers, metaData] = await Promise.all([
                HTTPService.get<JsonResultClass<boolean>>(`SplitEvents/CheckIntersection?projNr=${encodeURIComponent(projNr)}&pIndex=${pIndex}&cuttingEdge=${encodeURIComponent(cuttingEdge instanceof Date ? cuttingEdge.toString() : cuttingEdge)}`),
                HTTPService.get("ResourcePlanningLookup/GetGruppen"),
                Helper.getMetaData("splittingDialog")
            ]);
            if (result.Code == 1) {
                NotificationHelper.showErrorMessage(result.Message);
                resolve(SplittingDialogResult.Error);
                return;
            }

            if (!result.Data) {
                resolve(SplittingDialogResult.NoAssignments);
                return;
            }

            const actionDataSource = SplittingDialogUtil.getProperty<ActionDataItem[]>(metaData, "actionDropDownData").sort((a, b) => {
                if (a.pos < b.pos) {
                    return -1;
                }
                if (a.pos < b.pos) {
                    return 1;
                }
                return 0;
            });
            const templates = SplittingDialogUtil.getProperty<{ parent: string; child: string; }>(metaData, "templates");
            const splitAssignmentActions: SplitAssignmentActions[] = result.AdditionalData.splitAssignmentsActions.Assignments;
            const splittingAssignment: Assignment = result.AdditionalData.splitAssignmentsActions.CuttingAssignment;
            const resource = result.AdditionalData.splitAssignmentsActions.Resource;

            const assignmentData: StringKeyDictionary<SplitAssignmentActions> = {}
            assignmentData[splittingAssignment.IsGuid] = {
                Assignment: splittingAssignment,
                AvailableActions: null,
                DefaultAction: null,
                Resource: resource
            };
            splitAssignmentActions.forEach((assignmentAction) => {
                assignmentData[assignmentAction.Assignment.IsGuid] = assignmentAction
            })

            const targetElement = $("<div>");
            $("body").append(targetElement);

            const root = ReactDOM["createRoot"](targetElement[0]);

            const onClose = (result: SplittingDialogResult) => {
                //root.unmount();
                targetElement[0].remove();
                targetElement.remove();
                resolve(result);
            };

            const onError = (error: any) => {
                console.error(error);
                NotificationHelper.showErrorMessage("Unexpected error occured");
                onClose(SplittingDialogResult.Error)
            }

            //const root = createRoot(targetElement[0]);


            root.render(
                <>
                    <SplittingWrapper
                        splitAssignmentActions={splitAssignmentActions}
                        onClose={onClose}
                        staticData={{
                            actions: actionDataSource,
                            containers: containers,
                            resource: resource,
                            splittingAssignment: splittingAssignment,
                            templates: templates,
                            assignmentData: assignmentData,
                            cuttingEdge: cuttingEdge,
                            suggestionsActive: this.getProperty<boolean>(metaData, "suggestionsActive")
                        }}
                        onError={onError}
                        wrapperType={wrapperType}
                        markEvent={markEvent}
                    />
                </>);
        });
    }

    private static getProperty = <T extends any = any>(metaData: Metadata, propertyName: string) => {
        const objects = metaData.additional.objects;
        const obj = objects.find(o => o.name.toLowerCase() === propertyName.toLowerCase());
        return obj.data as T;
    }
}